import type { CommerceCustomer, CommerceCustomerSession } from "@teqtank/commerce-contracts";
import { CommerceError } from "../errors/commerce-error.js";

export function resolveCommerceCustomerSession(
    value: CommerceCustomerSession,
): CommerceCustomerSession {
    if (
        !value ||
        !["anonymous", "authenticating", "authenticated", "expired"].includes(value.status)
    )
        throw new CommerceError(
            "customer-session-invalid",
            "Commerce Gateway returned an invalid customer session.",
        );
    const customer = value.customer === null ? null : resolveCustomer(value.customer);
    if (value.status === "authenticated" && customer === null)
        throw new CommerceError(
            "customer-session-invalid",
            "An authenticated customer session must include a customer.",
        );
    return Object.freeze({
        ...value,
        customer,
        authenticatedAt: value.authenticatedAt === null ? null : new Date(value.authenticatedAt),
        expiresAt: value.expiresAt === null ? null : new Date(value.expiresAt),
    });
}

function resolveCustomer(value: CommerceCustomer): CommerceCustomer {
    if (!value || !value.id?.trim() || !value.email?.trim())
        throw new CommerceError(
            "customer-session-invalid",
            "Commerce Gateway returned an invalid customer identity.",
        );
    return Object.freeze({
        ...value,
        addresses: Object.freeze(
            [...(value.addresses ?? [])].map((item) =>
                Object.freeze({ ...item, address: Object.freeze({ ...item.address }) }),
            ),
        ),
        savedPaymentMethods: Object.freeze(
            [...(value.savedPaymentMethods ?? [])].map((method) => Object.freeze({ ...method })),
        ),
    });
}
